import { format } from 'date-fns'

/**
 * Format a UTC timestamp as relative time (e.g., "5 minutes ago")
 * @param timestamp - UTC timestamp string
 * @returns Formatted relative time string
 */
export function formatTimeAgo(timestamp: string): string {
  return formatDistanceToNow(new Date(timestamp + 'Z'))
}

/**
 * Format a UTC timestamp as a full date and time string
 * @param timestamp - UTC timestamp string
 * @param formatStr - Optional date-fns format string (defaults to 'PPpp')
 * @returns Formatted date string in local timezone
 */
export function formatLocalDateTime(timestamp: string, formatStr: string = 'PPpp'): string {
  return format(new Date(timestamp + 'Z'), formatStr)
}

/**
 * Format a UTC timestamp as time only (e.g., "3:30 PM")
 * @param timestamp - UTC timestamp string
 * @returns Formatted time string in local timezone
 */
export function formatLocalTime(timestamp: string): string {
  return format(new Date(timestamp + 'Z'), 'h:mm a')
}

/**
 * Simple format distance to now without dependencies
 * @param date - Date string or Date object
 * @returns Formatted relative time string
 */
export function formatDistanceToNow(date: string | Date): string {
  const now = new Date()
  const then = new Date(date)
  const seconds = Math.floor((now.getTime() - then.getTime()) / 1000)
  
  if (seconds < 60) return 'just now'
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`
  
  return then.toLocaleDateString()
}